import { render, staticRenderFns } from "./InvoiceReferralsWidget.vue?vue&type=template&id=3a160425&scoped=true"
import script from "./InvoiceReferralsWidget.vue?vue&type=script&lang=js"
export * from "./InvoiceReferralsWidget.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReferralsWidget.vue?vue&type=style&index=0&id=3a160425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a160425",
  null
  
)

export default component.exports